import React, { useEffect, useState } from "react";
import "./CinematicTimeline.css";
import ParticleBackground from "../components/ParticleBackground";
import img1 from "../assets/Times/Time1.jpeg";
import img2 from "../assets/Times/Time2.jpeg";
import img3 from "../assets/Times/Time3.jpeg";
import img4 from "../assets/Times/Time4.jpeg";
import img5 from "../assets/Times/Time5.jpeg";
import img6 from "../assets/Times/Time6.jpeg";
import img7 from "../assets/cards/card2.jpeg";
import img8 from "../assets/cards/card3.jpeg";
import img9 from "../assets/cards/card5.jpeg";

const conversations = [
  {
    id: "01",
    title: "We Turn “Seen” Into “Did You See This?”",
    images: [
      img1,
      img2,
      img3,
      img4,
      img5,
      img6,

    ],
    text: [
      <>
        Today, brands are dinner table debates. Products are personality
        traits. Instagram posts become first impressions. LinkedIn becomes a
        founder's stage. WhatsApp forwards build trust faster than billboards.
        And the brands people remember are rarely the ones shouting the
        loudest, they’re the ones people naturally bring up over chai breaks
        and coffee dates.
      </>,

      <>
        That's when we realised something. Content has become a commodity.
        Culture hasn’t. <em>Malika notices things nobody else notices.
          Sid asks questions nobody else asks. This place is serious about
          creativity, not about pretending to be serious.
          Doesn’t that make us anti-culture?</em>
      </>,

      <>
        Anyone can make a reel. Very few brands become part of the conversation
        after the reel is over. That became our obsession, before Obsession
        became everyone’s obsession.
        <em> We never took the shortcut that One Wish Willow offered.</em>
      </>,
    ],
  },

  {
    id: "02",
    title: "From Solving Equations to Solving Problems for Brands",
    images: [
      img7,
      
    ],
    text: [
      <>
        Sid’s journey began far away from advertising, in the lecture halls
        and infinity corridors of IIT Bombay. An institute with its own
        language, traditions, inside jokes and culture.
      </>,

      <>
        While everyone else was busy solving equations, Sid found himself
        fascinated by another kind of chemistry, the one between stories
        and people.
      </>,

      <>

        <em>
          Imagine clearing IIT... only to voluntarily enter marketing. That's either passion or a beautifully documented midlife crisis that started way early, in his 20s. I feel for him.
        </em>
      </>,

      <>
        After graduating, he spent years directing commercials, producing
        shows for Netflix and documentaries for Amazon, and learning one
        lesson over and over again:
        <em> A great film gets people talking. A great brand keeps the
          conversation alive.</em>
      </>,
    ],
  },

  {
    id: "03",
    title: "She Inherited the Business Instinct. The Storytelling Was Her Idea",
    images:[img8],
    text: [
      <>
        Malika grew up where business wasn't a profession. It was everyday
        life. From helping build Henfruit with her family to launching her
        own fashion label, Pashadora, she saw something fascinating.
        <em> People don't just wear clothes, they wear beliefs.</em>
      </>,

      <>
        Every wardrobe tells a story long before the person wearing it says
        a word. As her designs found their way into Punjabi music videos and
        films, storytelling slowly stopped being something around her.
        <em> It became something she wanted to build.</em>
      </>,

      <>

        <em>Malika can spot visual inconsistencies from across the room. I can barely spot typos even after the third coffee. Now I know why she loves chai. </em>
      </>,
    ],
  },

  {
    id: "04",
    title: "Why We Question Everything?",
    images:[img1],
    text: [
      <>
        One came with kadak chai. The other came with strong coffee. One
        brought the entrepreneur's instinct. The other brought the
        storyteller’s voice. Together, they shared the same belief.
        <em> The best ideas are brewed before they're built.</em>
      </>,

      <>
        Not in boardrooms, not inside presentations, but around conversations.
        That's why The Culture Capsule doesn't begin with deliverables.
        <em> It begins with questions.</em> We question the founder. We
        understand the audience. Sometimes we question each other.
        <em> Then we question the question.</em>
      </>,

      <>
        Only when the conversation feels right do we start building.
        <em> Every week, we quietly bury a few perfectly decent ideas. They didn't deserve to die. They just weren't unforgettable. People can forget us, but they shouldn’t forget the campaigns. Such a selfless endeavor. Marketing.</em>
      </>,



      <>
        Brand identities. Films. Content. SEO. Performance.
        <em> Everything else is simply execution.</em>
      </>,
    ],
  },

  {
    id: "05",
    title: "We Want to Live Rent-Free in Your Head.",
    images:[img9],
    text: [
      <>
        Think about the brands you still quote today.
      </>,

      <>
        <em>"Thanda Matlab Coca-Cola."</em>
      </>,

      <>
        <em>"Mentos. Dimaag Ki Batti Jala De."</em>
      </>,

      <>
        <em>"Chutki Mein Chipkaaye. Fevikwik."</em>
      </>,

      <>
        The campaigns ended years ago. The conversations never did.
        <em> That's the difference. A campaign has a deadline. A brand
          story doesn't.</em>
      </>,

      <>
        Today, storytelling isn't confined to a television commercial.
        It lives in Instagram comments, LinkedIn posts, WhatsApp groups,
        late-night founder calls, chai breaks, coffee dates.
      </>,

      <>
        Every interaction is another chance to move the story forward, to
        become memorable.
        <em> Every conversation is another chance to become culture.</em>
      </>,

      <>
        That's why we don't just build campaigns.
        <em> We help brands earn a place in everyday conversations.</em>
      </>,

      <>
        Because brands aren't built in one viral reel or one billboard.
        <em> They're built every single day.</em>
      </>,

      <>

        <em>  I'm convinced great advertising occupies the same part of the brain that stores embarrassing memories from Class 8. It simply refuses to leave. That’s what we strive to do here. And we don’t leave our office until then. It’s 8 PM now. I will leave in half an hour but this copy will be on the website, forever.</em>
      </>,



      <>

        One conversation. One cup of kadak chai. One cup of strong coffee.

      </>,
    ],
  },
];
function CinematicTimeline() {
  const [visibleMessages, setVisibleMessages] = useState({});
  useEffect(() => {
    const items = document.querySelectorAll(".timeline-item");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      {
        threshold: 0.15,
      }
    );

    items.forEach((item) => observer.observe(item));

    const updateTimeline = () => {
      const timeline = document.querySelector(".timeline");
      const progressLine = document.querySelector(".timeline-progress");
      const progressDot = document.querySelector(
        ".timeline-progress-dot"
      );

      if (!timeline || !progressLine || !progressDot) return;

      const rect = timeline.getBoundingClientRect();

      const progress = Math.min(
        Math.max(
          (window.innerHeight - rect.top) / rect.height,
          0
        ),
        1
      );

      const progressHeight = progress * rect.height;

      progressLine.style.height = `${progressHeight}px`;
      progressDot.style.top = `${progressHeight}px`;
    };

    window.addEventListener("scroll", updateTimeline);

    updateTimeline();

    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", updateTimeline);
    };
  }, []);

  return (
    <section className="cinematic-wrapper">

      <ParticleBackground />

      <div className="cinematic-glow glow-one"></div>
      <div className="cinematic-glow glow-two"></div>

      {/* HERO */}

      <div className="timeline-hero">

        <div className="hero-eyebrow">
          <span></span>
          OUR STORY
          <span></span>
        </div>

        <h1>
          The Culture
          <br />
          <em>Behind</em> The Capsule
        </h1>

        <p>
          Every great idea starts with a simple question.
          Ours started with a slightly more complicated one.
        </p>

        <div className="hero-question">

          <span className="quote-mark">“</span>

          <p>
            Why do some brands become part of everyday
            conversations, while others disappear the moment
            the campaign ends?
          </p>

          <span className="question-line"></span>

        </div>

        <div className="hero-intro">

          <p>
            Or worse still, why do some companies just remain
            companies, and never become brands?
          </p>

          <p>
            That question stayed with us through countless
            cups of chai and even more cups of coffee.
          </p>

          <p>
            Malika always ordered chai. Sid never moved beyond
            his black coffee. Somewhere between the two,
            <strong> The Culture Capsule was brewed.</strong>
          </p>



          <p className="hero-highlight">
            And even today, the chai gets colder. The coffee gets refilled. The ideas keep getting better. These creative people I tell you!
          </p>

          <p>
            The more they spoke, the clearer it became.
            There was a time when businesses only needed
            customers. Today, founders need communities.
          </p>

          <p>
            There was a time when companies could simply exist.
            Today, they need to stand for something.
          </p>

          <p>
            The old-school marketing, as we have known it
            for decades, has become irrelevant.
          </p>

        </div>

        <div className="scroll-indicator">
          <span>SCROLL TO EXPLORE</span>
          <div className="scroll-line"></div>
        </div>

      </div>


      {/* TIMELINE */}

      <div className="timeline">

        <div className="timeline-base"></div>

        <div className="timeline-progress"></div>

        <div className="timeline-progress-dot"></div>

        {conversations.map((conversation, index) => (

          <article
            key={conversation.id}
            data-conversation={conversation.id}
            className={`timeline-item ${index % 2 === 0 ? "left" : "right"
              }`}
          >

            <div className="timeline-dot">
              <span>{conversation.id}</span>
            </div>

            <div className="timeline-content story-layout">

              {/* ================= LEFT : STORY ================= */}
              <div className="story-copy">

                <div className="story-heading">

                  <span className="story-number">
                    {conversation.id}
                  </span>

                  <span className="story-heading-line"></span>

                  <span className="story-label">
                    THE CULTURE CAPSULE
                  </span>

                </div>

                <h2>
                  {conversation.title}
                </h2>

                <div className="story-text">

                  {conversation.text.map((paragraph, index) => (
                    <p key={index}>
                      {paragraph}
                    </p>
                  ))}

                </div>

              </div>


              {/* ================= RIGHT : PHOTO COLLAGE ================= */}
              <div className="story-gallery">

                {conversation.images?.map((image, index) => (
                  <div
                    className={`gallery-image gallery-image-${index + 1}`}
                    key={image}
                  >
                    <img
                      src={image}
                      alt={`${conversation.title} ${index + 1}`}
                      loading="lazy"
                    />
                  </div>
                ))}

              </div>

            </div>
          </article>

        ))}

      </div>

      {/* END */}

      <div className="timeline-ending">

        <span className="ending-line"></span>

        <p>
          And this is only the beginning.
        </p>

        <h3>
          Let's make something
          <em> worth talking about.</em>
        </h3>

      </div>

    </section>
  );
}

export default CinematicTimeline;